<template>
  <div id="page-solution" class="page">
    <header class="header">应用AI与loT技术重构社会、赋能行业</header>
    <p class="subtitle">Reconstructing society and enabling industry</p>
    <section>
      <header class="section-header" style="margin-bottom: 30px;">弦熵科技新零售人工智能生态SaaS系统</header>
      <div class="section-content">
        <div class="role">
          <img src="/static/solution-xianshang.png"/>
          <header>弦熵科技</header>
          <p>无人值守售货设备</p>
          <p>设备管理物联平台</p>
          <p>多维度AI识别引擎</p>
          <p>辅助供应链搭建完善</p>
          <p>C端售后服务sop培训</p>
          <p>24H客服及时响应</p>
          <p>专业运营指导</p>
        </div>
        <div class="role">
          <img src="/static/solution-operator.png"/>
          <header>运营商</header>
          <p>大数据差异化精细运营</p>
          <p>自动库存盘点</p>
          <p>智能规划补货</p>
          <p>合理分配运力</p>
          <p>sku优化匹配场景</p>
          <p>低成本高坪效</p>
          <p>AR互动营销</p>
          <p>虚拟导购机器人</p>
          <p>全场景应用想放哪就放哪</p>
        </div>
        <div class="role">
          <img src="/static/solution-deliverer.png"/>
          <header>消费者</header>
          <p>1秒急速完成商品识别，无感支付购物体验流畅</p>
          <p>全场景覆盖无处不在</p>
          <p>全品类商品供您所需</p>
          <p>微信+支付宝支付无门槛</p>
          <p>消费返积分便宜得实惠</p>
          <p>专业团队保障售后无忧</p>
          <p>AR小姐姐有趣互动</p>
        </div>
        <div class="role">
          <img src="/static/solution-consumer.png"/>
          <header>补货员</header>
          <p>抢单机制充分利用个人碎片时间</p>
          <p>软件简单明了易操作</p>
          <p>利用社会闲置劳动力创造大量就业岗位 创岗就业政府扶持</p>
          <p>完善的产品设计保障各方利益</p>
          <p>派单模式、 抢单模式，补货人员自由选择</p>
          <p>自助、派单补货，形式灵活</p>
        </div>
      </div>
    </section>
    <!--<section>
      <header class="section-header">场景解决方案</header>
      <div class="section-content">
        <div class="scene">
          <img src="/static/solution-scene.png"/>
          <header>自动售菜机租赁好还是购买好？</header>
          <p class="time">2018-05-31</p>
          <p class="content-text">请我是菜机租赁好还是购买好，几哈四大皆空哈数据库德哈卡阿贾克斯的哈会计阿斯啊实打实大声道阿斯达阿斯达所，阿斯达所阿斯达群无大声道...<a>阅读全文 ></a></p>
        </div>
        <div class="scene">
          <img src="/static/solution-scene.png"/>
          <header>自动售菜机租赁好还是购买好？</header>
          <p class="time">2018-05-31</p>
          <p class="content-text">请我是菜机租赁好还是购买好，几哈四大皆空哈数据库德哈卡阿贾克斯的哈会计阿斯啊实打实大声道阿斯达阿斯达所，阿斯达所阿斯达群无大声道...<a>阅读全文 ></a></p>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  name: 'solution',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#page-solution {

  .header {
    margin-top: 60px;
    font-size: 32px;
    color: #333333;
  }
  .subtitle {
    font-size: 14px;
    color: #888888;
  }
  section {
    margin-top: 80px;
  }
  .section-header {
    font-size: 28px;
    color: #333333;
  }

  .role {
    text-align: left;
    display: inline-block;
    vertical-align: top;
    border-radius: 10px;
    overflow: hidden;
    width: 300px;
    height: 600px;
    margin: 15px;
    box-shadow: 0px 5px 70px 10px rgba(0,0,0, .03);
    background-color: #ffffff;
    img {
      margin-bottom: 30px;
    }
    header {
      padding: 0 50px;
      font-size: 24px;
      color: #666666;
    }
    p {
      position: relative;
      padding: 0 50px;
      font-size: 16px;
      color: #808080;
    }
    p:before {
      content: '·';
      margin-left: -14px;
      margin-right: 10px;
    }
  }
  .scene {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    margin: 40px;
    border-radius: 10px;
    overflow: hidden;
    width: 600px;
    height: 420px;
    background-color: #ffffff;
    box-shadow: 0px 5px 70px 10px rgba(0,0,0, .03);

    header {
      font-size: 20px;
      color: #333333;
      padding: 0 20px;
    }
    .time {
      font-size: 12px;
      color: #b0b0b0;
      padding: 0 20px;
    }
    .content-text {
      font-size: 14px;
      color: #666666;
      padding: 0 20px;
      line-height: 30px;

      a {
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Solution.vue